module.exports = __webpack_public_path__ + "static/img/monitiornew6.74c56085.webp";